// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1mlUp","paramInput":"JobSimulator_paramInput__2ee9s","input":"JobSimulator_input__-rtPU"};